import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './ResponsiveMenuStyles.css';

const menuItems = [
    { label: 'Laptops', category: 'laptops' },
    { label: 'Desktops', category: 'desktops' },
    { label: 'Monitors', category: 'monitors' },
    { label: 'Computer Accessories', category: 'computer accessories' },
    { label: 'Keyboards', category: 'keyboards' },
    { label: 'Mouse', category: 'mouse' },
    { label: 'Printers', category: 'printers' },
    { label: 'Storage Devices', category: 'storage devices' },
    { label: 'Networking Devices', category: 'networking devices' },
    { label: 'Computer Components', category: 'computer components' },
    { label: 'Mobile Phones', category: 'mobile phones' },
    { label: 'Tablets', category: 'tablets' },
    { label: 'Mobile Accessories', category: 'mobile accessories' },
    { label: 'Smart Watches', category: 'smart watches' },
    { label: 'Televisions', category: 'televisions' },
    { label: 'Cameras', category: 'cameras' },
    { label: 'Headphones', category: 'headphones' },
    { label: 'Speakers', category: 'speakers' },
    { label: 'Gaming', category: 'gaming' },
    { label: 'Projectors', category: 'projectors' },
    { label: 'Power Banks', category: 'power banks' },
    { label: 'UPS', category: 'ups' },
];

const ResponsiveMenu = ({ isOpen = false, onClose = () => {} }) => {
    const [isDepartmentsOpen, setIsDepartmentsOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const menuRef = useRef(null);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const toggleDepartments = () => {
        setIsDepartmentsOpen(!isDepartmentsOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleCategoryClick = (category) => {
        setIsDepartmentsOpen(false);
        navigate(`/category/${encodeURIComponent(category)}`);
        onClose(); // Close mobile menu after navigation
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsDepartmentsOpen(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Reset dropdowns when mobile menu closes
    useEffect(() => {
        if (!isOpen) {
            setIsDepartmentsOpen(false);
            setIsDropdownOpen(false);
        }
    }, [isOpen]);

    // Close mobile menu when clicking overlay
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('navbar') && isOpen) {
            onClose();
        }
    };

    return (
        <nav className={`navbar ${isOpen ? 'mobile-menu-open' : ''}`} onClick={handleOverlayClick}>
            <div className="navbar-container">
                {/* All Departments Dropdown */}
                <div className="departments-dropdown" ref={menuRef}>
                    <button
                        onClick={toggleDepartments}
                        className="departments-button"
                        aria-label="All Departments"
                    >
                        <i className="fa fa-th-large"></i>
                        All Categories
                        <i className={`fa fa-chevron-${isDepartmentsOpen ? 'up' : 'down'}`}></i>
                    </button>

                    {isDepartmentsOpen && (
                        <div className="departments-menu">
                            <ul className="departments-list">
                                {menuItems.map((item, index) => (
                                    <li key={index} onClick={() => handleCategoryClick(item.category)}>
                                        {item.label}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Navigation Links */}
                <div className="navbar-links">
                    <Link to="/" className="nav-link" onClick={onClose}>Home</Link>
                   
                     
                </div>
            </div>
        </nav>
    );
};

export default ResponsiveMenu;
